import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/scribd': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M42.3 252.7C26.2 233.7 17.6 206.8 17.5 172.8 17.5 72.4 92.7 19.7 184.7 19.7 283.3 18.1 341.5 68.7 369 90.3L318.5 162.4 281.2 137.8 308.1 99.2C271.6 75.2 228.7 62.7 185.1 63.4 134.4 62.6 73.4 90.6 73.4 139.6 73.4 158.3 84.6 160.3 102 155.2 125.3 149.9 143.9 155.8 157.8 169.2 184.2 193.5 181 236.8 157.1 261.1 127.9 290.6 71.9 288.4 42.3 252.7zM360 258.6C344.5 239.8 321.1 229.2 296.8 230 258.7 228 225.7 258 226.3 297.2 225.6 314 232.3 330.2 244.7 341.5 258.8 355.4 277.7 361.2 301 355.9 318.4 350.8 329.6 352.8 329.6 371.5 329.6 375.8 329.1 380 328.2 384.2 311.5 425.1 268.7 448.6 206.8 448.6 154.9 448.8 104.4 432.2 62.7 401.3L96.4 361.9 60.8 334.5 0 406.3 15.4 420.1C67.9 466.9 135.8 492.6 206.1 492.3 257.5 492.3 300.5 481.8 339.7 448.2 396.8 396.8 393.9 299 360 258.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/scribd.js
// module id = YQhW
// module chunks = 144